import { persistRecorderState } from '../slices/recorderSlice';

/**
 * Redux Middleware to keep client storage in sync with Redux state changes
 */
export const storageSyncMiddleware = (store) => (next) => (action) => {
  const result = next(action);

  if (typeof window === 'undefined') {
    return result;
  }

  // Mirror the consultation AI-recorder panel to localStorage so it survives a
  // full browser reload (it is only cleared when a new consultation records).
  if (typeof action.type === 'string' && action.type.startsWith('recorder/')) {
    persistRecorderState(store.getState().recorder);
  }

  // Handle auth logout: clear user localStorage and session cookies
  if (action.type === 'auth/logout') {
    try {
      localStorage.removeItem('doctolikLoginInfo');
      localStorage.removeItem('isAciveDoctorAcc');
      persistRecorderState(null);
    } catch (e) {
      console.warn('[Redux Storage Sync] Failed to clear localStorage on logout:', e);
    }
  }

  // Handle doctor account toggle
  if (action.type === 'auth/setIsActiveDoctor') {
    try {
      localStorage.setItem('isAciveDoctorAcc', action.payload ? '1' : '0');
    } catch (e) {
      console.warn('[Redux Storage Sync] Failed to update isAciveDoctorAcc:', e);
    }
  }

  return result;
};

export default storageSyncMiddleware;
